import React, { useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import DialogAjuda from '@base/Dialog/Dialog';

import AjudaService from '@services/AjudaService';

export const ButtonHelp = ({ tipo }) => {
    const [ openDialog, setOpenDialog ] = useState(false);
    const [ ajuda, setAjuda ] = useState();

    const handleAjuda = () => {
        AjudaService.buscar(tipo)
            .then((res) => {
                setAjuda(res.data);
                setOpenDialog(true);
            })
    }

    const handleClose = () => setOpenDialog(false);

    return (
        <>
            <Tooltip title="Ajuda" TransitionComponent={Zoom}>
                <IconButton
                    color="default" 
                    size="medium"                    
                    aria-label="Ajuda"
                    onClick={handleAjuda}
                >
                    <HelpOutlineIcon />
                </IconButton>
            </Tooltip> 

            { openDialog &&
                <DialogAjuda
                    title={ajuda.titulo}
                    openDialog={openDialog}
                    closeDialog={handleClose}
                    fullWidth={true}
                    maxWidth="lg"
                >
                    <div style={{ marginTop: "-25px" }} dangerouslySetInnerHTML={{ __html: ajuda.texto }} />
                </DialogAjuda>
            }
        </>
    )
}

export default ButtonHelp;